import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import { Formik } from 'formik';
import config from '../config';
import { useAuth } from "../context/auth";

export default function Login() {
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [mode, setMode] = useState('login');
    const { setAuthToken } = useAuth();

    function submit(values, { setSubmitting }) {
        const route = mode === 'registration' ? 'registration' : 'login';
        fetch(`${config.API()}${route}`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                login: values.login,
                pwd: values.pwd
            })
        })
            .then(response => response.json())
            .then(data => {
                if(data.token) {
                    setAuthToken({token: data.token, username: values.login, role: data.role, config: data.config});
                    setLoggedIn(true);
                }else{
                    alert(JSON.stringify(data));
                }
            })
            .catch(error => {
                console.error(`Failed to ${route}`, error);
                alert('Request failed. Check API availability and browser console.');
            })
            .finally(() => setSubmitting(false));
    }

    if (isLoggedIn) {
        return ( <Redirect to="/" />);
    }

    return (
        <div className="container">
            <div className="card shadow w100">
                <div className="card-header py-3"><h2 className="m-0 font-weight-bold l"> Admin </h2></div>
                <div className="card-body">
                    <div className="row justify-content-center">
                        <div className="col-xl-10 col-lg-12 col-md-9">
                            <div className="card o-hidden border-0 shadow-lg my-5">
                                <div className="card-body p-0">
                                    <div className="row">

                                        <div className="col-lg-12">
                                            <div className="p-5">
                                                <Formik
                                                    initialValues={{ login: '', pwd: ''}}
                                                    onSubmit= {submit}
                                                >
                                                    {({
                                                          values,
                                                          handleSubmit,
                                                          handleChange,
                                                          isSubmitting
                                                      }) => (
                                                        <form className="user"  onSubmit={handleSubmit}>
                                                            <div className="text-center mb-4">
                                                                <h1 className="h4 text-gray-900">
                                                                    {mode === 'registration' ? 'Create Account' : 'Welcome Back'}
                                                                </h1>
                                                                <p className="small text-muted mb-0">
                                                                    {mode === 'registration'
                                                                        ? 'Create a new admin account'
                                                                        : 'Sign in to continue'}
                                                                </p>
                                                            </div>
                                                            <div className="form-group">
                                                                <input type="text"
                                                                       name = "login"
                                                                       className="form-control form-control-user"
                                                                       id="exampleInputEmail"
                                                                       placeholder="Login"
                                                                       onChange={handleChange}
                                                                       value={values.login}
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <input type="password"
                                                                       name = "pwd"
                                                                       className="form-control form-control-user"
                                                                       id="exampleInputPassword"
                                                                       placeholder="Password"
                                                                       onChange={handleChange}
                                                                       value={values.pwd}
                                                                />
                                                            </div>
                                                            <button type="submit" disabled={isSubmitting} className={`btn btn-user btn-block ${mode === 'registration' ? 'btn-info' : 'btn-primary'}`}>
                                                                <i className={`fas fa-fw ${mode === 'registration' ? 'fa-registered' : 'fa-sign-in-alt'}`}></i>{' '}
                                                                {mode === 'registration' ? 'Create Account' : 'Login'}
                                                            </button>
                                                            <div className="text-center mt-4">
                                                                {mode === 'registration' ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link p-0"
                                                                        onClick={() => setMode('login')}
                                                                    >
                                                                        Already have an account? Login
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link p-0"
                                                                        onClick={() => setMode('registration')}
                                                                    >
                                                                        No account yet? Register
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </form>
                                                    )}
                                                </Formik>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

